// Atualização automática: quando sai uma versão nova do jogo, o navegador de quem está jogando recarrega sozinho
// (sem precisar de Ctrl+F5). Confere a cada minuto, quando a aba volta a ficar visível e quando a conexão volta.
declare const __BUILD__: string;

let reloading = false;
async function check() {
  if (reloading) return;
  try {
    const r = await fetch('/version.json', { cache: 'no-store' });
    if (!r.ok) return;
    const { v } = (await r.json()) as { v: string };
    if (v && v !== __BUILD__) {
      reloading = true;
      const bar = document.createElement('div');
      bar.className = 'update-bar';
      bar.textContent = 'Nova versão do jogo! Atualizando em 3 segundos...';
      document.body.appendChild(bar);
      setTimeout(() => location.reload(), 3000);
    }
  } catch { /* servidor reiniciando: tenta de novo depois */ }
}

export function startUpdateWatch() {
  setInterval(check, 60_000);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) void check(); });
  window.addEventListener('online', () => void check());
}
/** chamado quando a conexão do jogo volta (o servidor reinicia a cada atualização) */
export const checkUpdateNow = () => { setTimeout(check, 1500); };
